// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d11902bd","223":"b767712e","239":"a56347b7","667":"0352a893"}[chunkId] + ".chunk.js";
};